export const frVideos = {
    // VIDEOS
    'videos.name': 'Vidéo',
    'videos.picker.synchronize': 'Synchronisation de la vidéo...',
    'videos.picker.duration': 'Durée: ',
    'videos.picker.secondary.loading.message': 'Chargement de la vidéo...',

    'videos.list.pageTitle': 'Instant Digital',
    'videos.list.sectionTitle': 'Vidéos',
    'videos.list.emptyLabel': 'Aucune vidéo pour le moment.',
    'videos.list.actions.addVideo': 'Ajouter une vidéo',
    'videos.list.table.emptyLabel': "Il n'y a pas de vidéo pour le moment.",
    'videos.list.table.header.info': 'Informations',
    'videos.list.table.header.owner': 'Propriétaire',
    'videos.list.table.header.nbShops': 'Nombre de centres',
    'videos.list.table.header.duration': 'Durée',
    'videos.list.table.header.type': 'Type',
    'videos.list.table.state.drafts': 'Brouillon',
    'videos.list.table.state.draft': 'Brouillon',
    'videos.list.table.state.published': 'Publié',
    'videos.list.table.state.unpublished': 'Annulé',
    'videos.list.table.filters.favoriteShops': 'Mes centres favoris',
    'videos.list.table.filters.apply': 'Appliquer',
    'videos.list.table.filters.label.state': 'État :',
    'videos.list.popup.title': 'Synchronisation des bons plans',
    'videos.list.popup.pleaseWait': 'Merci de patienter durant la synchronisation',

    // VIDEOS >> CREATE

    'videos.create.pageTitle': 'Création instant digital',
    'videos.create.input.name': 'Saisissez ici le nom de la vidéo *',
    'videos.create.input.code': 'Saisissez ici le code de la vidéo',
    'videos.create.input.floatingLabelName': 'Nom',
    'videos.create.input.floatingLabelCode': 'Code',
    'videos.create.tabs.info': 'Informations',
    'videos.create.tabs.audience': 'Audience',
    'videos.create.tabs.notifications': 'Notifications',
    'videos.create.tabs.audiences.treeTitle': 'Choix sectorisation',
    'videos.create.tabs.informations.generalSectionTitle': 'Informations générales',
    'videos.create.tabs.informations.publishSectionTitle': 'Publication',
    'videos.create.tabs.informations.inputs.description':
        'Saisissez ici la description de la vidéo',
    'videos.create.tabs.informations.inputs.floatingLabelDescription': 'Description',
    'videos.create.tabs.informations.inputs.floatingLabelCategory': 'Catégorie',
    'videos.create.tabs.informations.inputs.category.instantdigital': 'Instant digital',
    'videos.create.tabs.informations.inputs.category.emidas': 'Mise à jour emidas',
    'videos.create.tabs.informations.inputs.category.tutoriel': 'Tutoriel',
    'videos.create.tabs.informations.inputs.category.entreprise': "Vie d'entreprise",
    'videos.create.tabs.informations.inputs.hint': 'Sélectionnez une catégorie',
    'videos.create.tabs.informations.select.owner.sectionTitle': 'Propriétaire',
    'videos.create.tabs.informations.select.owner.title': 'Sélectionnez le propriètre du bon plan',
    'videos.create.tabs.informations.select.owner.floatingLabelTitle': 'Propriétaire',
    'videos.create.tabs.informations.select.owner.listTitle': 'Choix du propriétaire',
    'videos.create.tabs.informations.select.owner.listInputLabel': 'Chercher un utilisateur siège',
    'videos.create.tabs.informations.select.owner.listCloseLabel': 'Fermer',
    'videos.create.tabs.informations.select.docs.addPhoto': 'Ajouter une photo',
    'videos.create.tabs.informations.select.docs.addPhotoLabel': 'Visuel photo',
    'videos.create.tabs.informations.select.docs.cancelLabel': 'Annuler',
    'videos.create.tabs.informations.select.docs.extract': 'Ou extraire le visuel de la vidéo',
    'videos.create.tabs.informations.select.docs.extractBtn': 'Parcourir',
    'videos.create.tabs.informations.select.docs.title': 'Ajouter la vidéo',
    'videos.create.tabs.informations.select.docs.label': 'Fichier Vidéo',
    'videos.create.tabs.informations.dialog.title': 'Extraire le visuel de la vidéo',
    'videos.create.tabs.informations.dialog.validate': 'Extraire',
    'videos.create.tabs.informations.dialog.cancel': 'Annuler',
    'videos.create.tabs.informations.dialog.floatingLabelText':
        'Sélection dans la vidéo à une durée donnée',
    'videos.create.tabs.informations.dialog.hintText': 'Ex. 02:54',
    'videos.create.tabs.informations.publish.publishBtn': 'Publier',
    'videos.create.tabs.informations.publish.cancelBtn': 'Annuler la publication',
    'videos.create.tabs.notifs.time': '--',
    'videos.create.tabs.notifs.floatingLabelTime': 'Heure de la relance',
    'videos.create.tabs.notifs.date': '--',
    'videos.create.tabs.notifs.floatingLabelDate': 'Date de la relance',
    'videos.create.tabs.notifs.dateSwitch': 'Date unique',
    'videos.create.tabs.notifs.recursiveTime': '--',
    'videos.create.tabs.notifs.floatingLabelRecursiveTime': 'Heure de répétition',
    'videos.create.tabs.notifs.recursiveTimeSwitch': 'Répétition',
    'videos.create.tabs.notifs.repeat': '--',
    'videos.create.tabs.notifs.floatingLabelRepeat': 'Tous les XX jours',
    'videos.create.tabs.notifs.noneLabel': 'Aucune relance',
    'videos.create.tabs.notifs.autoSend': 'Relance automatique',

    // VIDEOS >> DETAILS

    'videos.details.pageTitle': 'Détails instant digital',
    'videos.details.input.name': 'Saisissez ici le nom de la vidéo *',
    'videos.details.input.code': 'Saisissez ici le code de la vidéo',
    'videos.details.input.floatingLabelName': 'Nom',
    'videos.details.input.floatingLabelCode': 'Code',
    'videos.details.dialog.title': 'Suppression de la vidéo',
    'videos.details.dialog.content': 'Êtes-vous sûr de vouloir supprimer cette vidéo ?',
    'videos.details.dialog.validateLabel': 'Supprimer',
    'videos.details.dialog.cancelLabel': 'Annuler',
    'videos.details.actions.save': 'Enregistrer',
    'videos.details.actions.remove': 'Supprimer',
    'videos.details.actions.previous': 'Vidéos',
    'videos.details.tabs.info': 'Informations',
    'videos.details.tabs.audience': 'Audience',
    'videos.details.tabs.notifications': 'Notifications',
    'videos.details.tabs.informations.generalSectionTitle': 'Informations générales',
    'videos.details.tabs.informations.publishSectionTitle': 'Publication',
    'videos.details.tabs.informations.inputs.description':
        'Saisissez ici la description de la vidéo',
    'videos.details.tabs.informations.inputs.floatingLabelDescription': 'Description',
    'videos.details.tabs.informations.inputs.floatingLabelCategory': 'Catégorie',
    'videos.details.tabs.informations.select.owner.sectionTitle': 'Propriétaire',
    'videos.details.tabs.informations.select.owner.title': 'Sélectionnez le propriètre de la vidéo',
    'videos.details.tabs.informations.select.owner.floatingLabelTitle': 'Propriétaire',
    'videos.details.tabs.informations.select.owner.listTitle': 'Choix du propriétaire',
    'videos.details.tabs.informations.select.owner.listInputLabel': 'Chercher un utilisateur siège',
    'videos.details.tabs.informations.select.owner.listCloseLabel': 'Fermer',
    'videos.details.tabs.informations.select.docs.addPhoto': 'Ajouter une photo',
    'videos.details.tabs.informations.select.docs.addPhotoLabel': 'Visuel photo',
    'videos.details.tabs.informations.select.docs.cancelLabel': 'Annuler',
    'videos.details.tabs.informations.select.docs.extract': 'Ou extraire le visuel de la vidéo',
    'videos.details.tabs.informations.select.docs.extractBtn': 'Parcourir',
    'videos.details.tabs.informations.select.docs.title': 'Ajouter la vidéo',
    'videos.details.tabs.informations.select.docs.label': 'Fichier Vidéo',
    'videos.details.tabs.informations.select.publisher.sectionTitle': 'Publier en tant que',
    'videos.details.tabs.informations.select.publisher.title': 'Sélectionnez le nom du publieur',
    'videos.details.tabs.informations.select.publisher.floatingLabelTitle': 'Publier en tant que',
    'videos.details.tabs.informations.select.publisher.listTitle': 'Choix du publieur',
    'videos.details.tabs.informations.select.publisher.listInputLabel':
        'Chercher un utilisateur ou une équipe',
    'videos.details.tabs.informations.select.publisher.listCloseLabel': 'Fermer',
    'videos.details.tabs.informations.publish.publishBtn': 'Publier',
    'videos.details.tabs.informations.publish.cancelBtn': 'Annuler la publication',
    'videos.details.tabs.audiences.treeTitle': 'Choix sectorisation',
    'videos.details.tabs.notifs.time': '--',
    'videos.details.tabs.notifs.floatingLabelTime': 'Heure de la relance',
    'videos.details.tabs.notifs.date': '--',
    'videos.details.tabs.notifs.floatingLabelDate': 'Date de la relance',
    'videos.details.tabs.notifs.dateSwitch': 'Date unique',
    'videos.details.tabs.notifs.recursiveTime': '--',
    'videos.details.tabs.notifs.floatingLabelRecursiveTime': 'Heure de répétition',
    'videos.details.tabs.notifs.recursiveTimeSwitch': 'Répétition',
    'videos.details.tabs.notifs.repeat': '--',
    'videos.details.tabs.notifs.floatingLabelRepeat': 'Tous les XX jours',
    'videos.details.tabs.notifs.noneLabel': 'Aucune relance',
    'videos.details.tabs.notifs.autoSend': 'Relance automatique',
    'videos.details.tabs.notifs.manualSend': 'Relance manuelle',
    'videos.details.tabs.notifs.manualInfo':
        "Envoyer une notification de relance aux collaborateurs qui n'ont pas encore consulté la vidéo",
    'videos.details.tabs.notifs.manualBtnlabel': 'Relancer',
    'videos.details.tabs.notifs.notifsHistoryEmpty': "Pas d'historique de notifications",
    'videos.details.tabs.notifs.tableTitle': 'Historique des notifications',

    //Validators
    'validators.extractImageFromTime': 'Ce champ doit être de la forme mm:ss (ex: 02:54)',
    'validators.durationTooLong': 'Veuillez saisir un temps inférieur à la durée de la vidéo',

    // TOAST ERRORS
    'toast.apiErrors.VIDEO_CAN_NOT_BE_DELETED':
        'Impossible de supprimer une vidéo qui a été publiée',
    'toast.apiErrors.VIDEO_ALREADY_PUBLISHED': 'Cette vidéo est déjà publiée',
    'toast.apiErrors.VIDEO_ALREADY_UNPUBLISHED':
        "Cette vidéo est déjà à l'état publication annulée",
    'toast.apiErrors.VIDEO_MISSING_AUDIENCE':
        "Aucune audience n'est définie pour cette vidéo, il ne peut pas être publié",
    'toast.apiErrors.VIDEO_MISSING_FILE':
        'Un fichier vidéo doit être envoyé pour permettre de publié cet instant digital',
    'toast.apiErrors.VIDEO_FILE_NOT_READY':
        "Le traitement de la vidéo n'est pas encore terminé, merci de réessayer dans quelques instants",
    'toast.apiErrors.VIDEO_FILE_NOT_SUPPORTED':
        "Nous n'avons pas pu traiter cette vidéo, son format ne semble pas valide",
    'toast.apiErrors.VIDEO_CATEGORY_MISSING':
        "Aucune catégorie n'est définie pour cette video, elle ne peut pas être créee",

    'toast.error.video': "Impossible d'envoyer votre vidéo",
};
